// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__30_49","name":"Header_name__2WThL","birthday":"Header_birthday___iWqG","skeleton":"Header_skeleton__2ZW9Z"};